import { head } from "lodash-es";

import {
	RegistrationPromotion,
	RegistrationPromotionBadge,
	RegistrationPromotionResponseItem,
} from "./registration-promotion.model";

export function processRegistrationPromotion(rawItem: RegistrationPromotionResponseItem): RegistrationPromotion {
	const content = rawItem.content;
	const badges = {
		badgeLeft: {
			image: head(content.badgeImageLeft),
			title: head(content.badgeTitleLeft),
			subtitle: head(content.badgeSubtitleLeft),
		},
		badgeCenter: {
			image: head(content.badgeImageCenter),
			title: head(content.badgeTitleCenter),
			subtitle: head(content.badgeSubtitleCenter),
		},
		badgeRight: {
			image: head(content.badgeImageRight),
			title: head(content.badgeTitleRight),
			subtitle: head(content.badgeSubtitleRight),
		},
	} as Record<string, RegistrationPromotionBadge>;

	return {
		key: rawItem.documentKey,
		banner: head(content.image),
		title: head(content.title),
		subtitle: head(content.subtitle),
		infoText: head(content.infoText),
		terms: head(content.terms),
		additionalTerms: head(content.additionalTerms),
		badges: [badges.badgeLeft, badges.badgeCenter, badges.badgeRight].filter((badge) => !!badge.image),
	};
}
